<template>
  <div class="table-column__list">
    <label class="table-text form__label m-0 mb-1">Hidden projects:</label>
    <multiselect
      :options="projectsList"
      :showLabels="false"
      allow-empty
      label="name"
      multiple
      ref="multiselect"
      style="width: 400px;"
      track-by="name"
      v-model="activeState"
    >
      <template slot="option" slot-scope="props">
        <div
          @click.stop="changeActive(props.option)"
          class="option__desc"
        >
          {{ props.option.label }}
        </div>
      </template>
      <template slot="selection" slot-scope="{ values, isOpen }">
        <span
          class="multiselect__single"
          v-if="values.length && !isOpen"
        >
          {{ values.length }}/{{ projectsList.length }}
        </span>
      </template>
      <template slot="tag">
        <i></i>
      </template>
    </multiselect>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    tableName: {
      type: String
    },
    projectsList: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      activeState: [],
      disabledProjects: []
    }
  },
  computed: {
    ...mapGetters({
      getTableHiddenColumnKeys: 'frontView/getTableHiddenColumnKeys'
    }),
    getDisabledProjects () {
      return this.activeState.map(project => project.id)
    }
  },
  mounted () {
    this.setActiveState(this.projectsList)
    this.loadTableHiddenColumns(this.tableName)
      .then(response => {
        this.disabledProjects = this.getTableHiddenColumnKeys(this.tableName)
        this.setActiveState(this.projectsList)
        this.$emit('initialized', this.disabledProjects)
      })
      .catch(console.error)
      .finally(() => {
        this.isDataLoading = false
      })
  },
  methods: {
    ...mapActions({
      loadTableHiddenColumns: 'frontView/loadTableHiddenColumns',
      addHiddenColumnKey: 'frontView/addHiddenColumnKey',
      removeHiddenColumnKey: 'frontView/removeHiddenColumnKey'
    }),
    setActiveState (projects) {
      const disabledId = this.disabledProjects.slice()
      for (const i in projects) {
        if (disabledId.some(id => projects[i].id === id)) {
          this.activeState.push(projects[i])
        }
      }
      this.$emit('changeActive', this.disabledProjects)
      this.$forceUpdate()
    },
    changeActive (option) {
      this.$refs.multiselect.toggle()

      const indexItem = this.activeState.findIndex(project => project.id === option.id)

      if (indexItem !== -1) {
        this.activeState.splice(indexItem, 1)
        this.removeHiddenColumnKey({ tableName: this.tableName, key: option.id })
      } else {
        this.activeState.push(option)
        this.addHiddenColumnKey({ tableName: this.tableName, key: option.id })
      }

      this.$emit('changeActive', this.getDisabledProjects)
      this.$forceUpdate()
    }
  }
}
</script>
